/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { AdviceSeverities, AdviceTypes } from '../../consts';
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  serviceId: ZodTypes.Id,
});

export const GetDismissedAdvice = {
  id: 'dismissed-advice.get',
  tag: 'Advice',
  summary: 'Retrieve dismissed advice',
  description: 'Retrieve dismissed advice',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.serviceId}/dismissed-advice`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              id: ZodTypes.Id,
              createdAt: z.date(),
              info: z.string(),
              type: z.enum(AdviceTypes),
              severity: z.enum(AdviceSeverities),
              object: z.string().optional(),
              subObject: z.string().optional(),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
